import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { AlertService } from '../../services/alert/alert.service';
import { S3FileManagerService } from '../../services/s3-file-manager/s3-file-manager.service';
import { ModalComponent, ModalConfig } from '../modals/modal/modal.component';

@Component({
  selector: 'app-s3-create-folder-modal',
  standalone: false,
  templateUrl: './s3-create-folder-modal.component.html',
  styleUrl: './s3-create-folder-modal.component.scss',
})
export class S3CreateFolderModalComponent {
  @Input() currentPath = '';

  @Output() refreshList = new EventEmitter<void>();

  @ViewChild('modal') modal: ModalComponent;

  readonly modalConfig: ModalConfig = {
    titleText: 'New Folder',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    hideCloseButton: true,
  };

  folderName = '';

  saving = false;

  constructor(
    private alertService: AlertService,
    private s3FileManagerService: S3FileManagerService
  ) {}

  open(): void {
    this.modal.open();
  }

  save(): void {
    const name = this.folderName.trim();
    if (!name) return;
    this.saving = true;
    const path = `${this.currentPath}${name}/`;
    this.s3FileManagerService.createFolder(path).subscribe({
      next: () => {
        this.saving = false;
        this.modal.close();
        this.refreshList.emit();
      },
      error: () => {
        this.saving = false;
        this.alertService.showAlert('Error creating folder');
      },
    });
  }

  reset(): void {
    this.folderName = '';
    this.saving = false;
  }
}
